import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IPermissionFields {
		id?: any;
		selected?: any;
		organisationName?: any;
		parentId?: any;
		name?: any;
		description?: any;
		changedBy?: any;
		datestamp?: any;
		status?: any;
		isAssignable?: any;
		isRequired?: any;
		appId?: any;
}

export class PermissionFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public selected: IEntityModelField = { name: "selected", displayName: "Selected", fieldType: FieldType.Byte };
	public organisationName: IEntityModelField = { name: "organisationName", displayName: "Organisation", fieldType: FieldType.String, readOnly: true, required: true };
	public parentId: IEntityModelField = { name: "parentId", displayName: "Parent Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public name: IEntityModelField = { name: "name", displayName: "Name", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public description: IEntityModelField = { name: "description", displayName: "Description", fieldType: FieldType.String, pattern: "NameGeneric" };
	public changedBy: IEntityModelField = { name: "changedBy", displayName: "Changed By", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public isAssignable: IEntityModelField = { name: "isAssignable", displayName: "Is Assignable", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public isRequired: IEntityModelField = { name: "isRequired", displayName: "Is Required", fieldType: FieldType.Byte, pattern: "NameGeneric", required: true };
	public appId: IEntityModelField = { name: "appId", displayName: "App Id", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.selected);
		this.push(this.organisationName);
		this.push(this.parentId);
		this.push(this.name);
		this.push(this.description);
		this.push(this.changedBy);
		this.push(this.datestamp);
		this.push(this.status);
		this.push(this.isAssignable);
		this.push(this.isRequired);
		this.push(this.appId);
	}
}

export class PermissionDTO implements IEntityModel {
	protected permissionName: string = "PermissionModel";
	protected permissionKeyField: string = "id";
	protected permissionDisplayName: string = "Permission|Permissions";
	protected permissionFields = new PermissionFields();
	public get name(): string { return this.permissionName };
	public get keyField(): string { return this.permissionKeyField };
	public get displayName(): string { return this.permissionDisplayName };
	public get fields(): PermissionFields { return this.permissionFields };

	constructor() {};
}
